import RightArrowIcon from 'components/elements/icons/RightArrowIcon'
import React from 'react'
import styled from 'styled-components'

/**
 * 汎用ボタン
 */
const Button: React.FC<ButtonProps> = (props) => {
  return (
    <StyledButton {...props}>
      {props.withArrow && (
        // justify-content: space-between;での位置調整のため空divを使用
        <div />
      )}
      {props.children}
      {props.withArrow && <RightArrowIcon color={props.color} />}
    </StyledButton>
  )
}

/**
 * もとはPropsに一括定義されていたものをスタイル部分のみ抜き出して別typeとして定義
 */
export type ButtonStyle = {
  /** 背景色 */
  background?: string
  /** 文字色 */
  color?: string
  /** 強調表示 */
  bold?: boolean
  /** 外側余白 */
  margin?: string
  /** 内側余白 */
  padding?: string
  /** 右矢印の表示 */
  withArrow?: boolean
  /** 枠のスタイル */
  border?: string
}

/**
 * Buttonのタイプ定義
 */
export type ButtonProps = ButtonStyle & {
  /** 子要素 */
  children: React.ReactNode
  /** ボタンクリック時の処理 */
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

/**
 * ボタン用のStyle定義したdiv
 */
export const StyledButton = styled.div<{
  /** 背景色 */
  background?: string
  /** 文字色 */
  color?: string
  /** 強調表示 */
  bold?: boolean
  /** 外側余白 */
  margin?: string
  /** 内側余白 */
  padding?: string
  /** 右矢印の表示 */
  withArrow?: boolean
  /** 枠のスタイル */
  border?: string
}>`
  margin: ${(props): string => props.margin || '24px'};
  padding: ${(props): string => props.padding || '16px'};
  color: ${(props): string => props.color || 'var(--color-text)'};
  font-weight: ${(props): string => (props.bold ? 'bold' : 'normal')};
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  background: ${(props): string =>
    props.background || 'var(--color-background)'};
  border: ${(props): string => props.border || 'none'};
  border-radius: 240px;
  ${(props): string => (props.withArrow ? 'display: flex;' : '')}
  ${(props): string =>
    props.withArrow ? 'justify-content: space-between;' : ''}
  ${(props): string => props.border ? 'border: ' + props.border : ''}
`

export default Button
